// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"sH","contentFrame":"sI","button":"sJ","header":"sK","text":"sL","contentImage":"sM"};